import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {InvoicePageVO, useQueryInvoicePage} from "@/service/invoice.s";
import Box from "@mui/material/Box";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {WriteInvoice} from "@/pages/Invoice/WriteInvoice";
import {ViewInvoice} from "@/pages/Invoice/ViewInvoice";
import {Avatar} from "@mui/material";
import {permScope} from "@/helper/constant";
import {SellerAvatar} from "@/widget/SellerAvatar/SellerAvatar";

export const InvoiceListPage = () => {
    const {
        mutate: invoicePageMutate,
        data: invoicePageData,
        isPending: invoicePagePending,
    } = useQueryInvoicePage()
    const {role: {dataScope}, id} = useAuthInfo()

    const columns: GridColDef<InvoicePageVO>[] = [
        {field: "customerName", headerName: "客户名称", flex: 1.5, minWidth: 200},
        {
            field: "createdAt",
            headerName: "开票日期",
            headerAlign: "right",
            align: "right", valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "seller",
            headerName: "领用人",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
            display: "flex",
            valueGetter: (_, row) => ({creator: row.creator, seller: row.seller}),
            renderCell: SellerAvatar
        },
        {
            field: "invoiceMoney",
            headerName: "开票金额",
            headerAlign: "center",
            align: "center",
            flex: 0.8,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.invoiceMoney}`}</Box>
        },
        {
            field: "invoiceType",
            headerName: "开票类型",
            headerAlign: "center",
            align: "center",
            flex: 1
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "receivingMethod",
            headerName: "到账公司",
            headerAlign: "center",
            align: "center",
            flex: 1,
            valueFormatter: value => value || '-'
        },
    ];

    return (
        <ProTable<InvoicePageVO>
            loading={invoicePagePending}
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            renderDrawer={{view: <ViewInvoice mode={'drawer'}/>, write: <WriteInvoice/>}}
            columns={columns}
            data={invoicePageData?.data}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: InvoicePageVO) => {
                        return {businessId: row.id, instanceId: row.instanceId, updateForm: <WriteInvoice/>}
                    }
                }
            }}
            onSearch={(params) => {
                invoicePageMutate(params);
            }}
            code={"invoice"}
        />
    );
};
